/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SentTime/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function SentTime({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Inbound/Info/SentTime"
  
}) {
let smsCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'sms',
path: 'created_at',
format: fromFormat.dateISOToTime,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 marginTop={2}
 data="sms.created_at"
 format="/Data/format.js dateISOToTime"
 text={smsCreatedAtValueData}
/>
{children}
</React.Fragment>)
}